<template>
    <div class="kraken-title-wrapper">
        
            <h2 class="kraken-title">
                <span class="kraken-title-textparent">
                    {{ titleText }}
                </span>
            </h2>
        
        <!-- <span class="kraken-subtitle">{{ subTitleText }}</span> -->
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'

    export default Vue.extend({
        name: 'MainTitle',
        props: {
            titleText: String,
            subTitleText: String
        }
    })
</script>

<style scoped lang="scss">
    .kraken {
        &-title {
            font-size: 2.5rem;
            color: #fff;
            font-weight: 700;
            letter-spacing: 1.5px;
            text-shadow: 1px 1px 3px #121315;

            &-wrapper {
                width: 90vw;
                text-align: center;
                margin: auto;
            }

            &-textparent {
                text-align: center;
                position: relative;

                &::before {
                    content: '- Kraken Labs';
                    font-size: .95rem;
                    display: block;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    color: #fff;
                    transform: translateY(100%);
                    -webkit-transform: translateY(100%);
                    font-style: italic;
                    font-weight: 400;
                    letter-spacing: 1px;
                    text-shadow: 1px 1px 3px #121315;
                }
            }
        }

        @media SCREEN AND ( min-width: 768px ) {
            &-title {
                font-size: 9vmax;
            }

            &-wrapper {
                width: 80vw;
            }
        }

        @media SCREEN AND ( min-width: 1400px ) {
            &-title {
                font-size: 7vmax;

                &-textparent {
                    &::before {
                        content: '- Kraken Labs';
                        font-size: 1vmax;
                    }
                }
            }
        }

        &-subtitle {
            font-size: .8rem;
            color: #fff;
            text-align: right;
        }
    }
</style>